import api from "./utils";

const getIDSRules = async (params) => {
  // return await api.get(`/reddit/crawl/results?page=${page}&sort_by=${sort_by}&sort_direction=${sort_direction}&search=${search}`).then((results) => results.data);
  return await api.get(`/ids/rules`, { params }).then((results) => {
    let filename;

    switch (params["return_format"]) {
      case "json":
        filename = "misp.json";
        break;
      case "xml":
        filename = "misp.xml";
        break;
      case "openioc":
        filename = "misp.ioc";
        break;
      default:
        filename = "misp.rules";
        break;
    }

    const blob = new Blob([results.data]);
    console.log("BLOB ", results);
    const url = URL.createObjectURL(blob);

    // Step 3: Trigger downloading the object using that URL
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    a.click(); // triggering it manually
  });
};

export { getIDSRules };
